import React, { useState } from 'react';
import { TwoCol, FieldLabel, Secondary, Primary } from './shared';
import { SlDropdownMenu } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/input';
import EstimatedCostCard from './components/EstimatedCostCard';
import SlCalendarPicker, { CalendarDate } from 'src/components/BeaconV2Components/common/SlCalendarPicker/SlCalendarPicker';

export interface SpecsViewProps {
  onBack: () => void;
  onNext: () => void;
  productUrlCount?: number;
  retailerCount?: number;
  frequency?: 'daily' | 'weekly' | 'monthly';
  onFrequencyChange?: (f: 'daily' | 'weekly' | 'monthly') => void;
  onDatesChange?: (start: Date | null, end: Date | null) => void;
}

const SpecsView: React.FC<SpecsViewProps> = ({ onBack, onNext, productUrlCount = 0, retailerCount = 0, frequency = 'weekly', onFrequencyChange, onDatesChange }) => {
  const [start, setStart] = useState<Date | null>(null);
  const [end, setEnd] = useState<Date | null>(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false);
  const anchorRef = React.useRef<HTMLDivElement | null>(null);

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [s, e] = dates;
    const today = new Date();
    const todayMid = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    let adjustedEnd = e;
    if (e) {
      const eMid = new Date(e.getFullYear(), e.getMonth(), e.getDate());
      // Enforce end date must be at least the next day (cannot be today or earlier)
      if (eMid.getTime() <= todayMid.getTime()) {
        adjustedEnd = new Date(todayMid.getTime() + 24 * 60 * 60 * 1000);
      }
    }
    setStart(s);
    setEnd(adjustedEnd);
    onDatesChange && onDatesChange(s, adjustedEnd);
  };
  const shouldDisableDate = (_c: CalendarDate) => {
    const today = new Date();
    const d = _c.date;
    // zero-out time for both
    const a = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const b = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
    return a < b;
  };

  return (
    <TwoCol style={{ width: 1045 }}>
      <div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div>
            <FieldLabel>Agent Frequency</FieldLabel>
            <div style={{ display: 'flex', gap: 8, width: 240 }}>
              <SlDropdownMenu
                options={[
                  { id: 'daily', label: 'Daily' },
                  { id: 'weekly', label: 'Weekly' },
                  { id: 'monthly', label: 'Monthly' }
                ]}
                defaultLabel={{ daily: 'Daily', weekly: 'Weekly', monthly: 'Monthly' }[frequency]}
                selectedId={frequency}
                onChange={(opt) => onFrequencyChange && onFrequencyChange(opt.id as any)}
              />
            </div>
          </div>
        </div>

        <div style={{ height: 16 }} />
        <div>
          <FieldLabel>Date Range</FieldLabel>
          <div ref={anchorRef} style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <button
              onClick={() => setIsCalendarOpen(true)}
              style={{
                height: 32,
                width: 112,
                borderRadius: 4,
                border: '1px solid #E8E8ED',
                background: '#FFFFFF',
                padding: '5px',
                cursor: 'pointer',
                fontSize: 14,
                color: '#031425'
              }}
            >
              {start ? start.toLocaleDateString() : 'MM/DD/YYYY'}
            </button>
            <span style={{ color: '#031425' }}>→</span>
            <button
              onClick={() => setIsCalendarOpen(true)}
              style={{
                height: 32,
                width: 112,
                borderRadius: 4,
                border: '1px solid #E8E8ED',
                background: '#FFFFFF',
                padding: '5px',
                cursor: 'pointer',
                fontSize: 14,
                color: '#031425'
              }}
            >
              {end ? end.toLocaleDateString() : 'MM/DD/YYYY'}
            </button>
          </div>
          <SlCalendarPicker
            open={isCalendarOpen}
            onClose={() => setIsCalendarOpen(false)}
            shouldDisableDate={shouldDisableDate}
            handleDateChange={handleDateChange as any}
            selectedDateRange={[start as any, end as any] as unknown as Date[]}
            anchorEl={anchorRef.current}
            placement="bottom-start"
          />
        </div>

        <div style={{ height: 16 }} />

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
          <Secondary onClick={onBack} style={{ borderRadius: 4, border: '1px solid #E8E8ED' }}>Back</Secondary>
          <Primary onClick={onNext} disabled={!start} style={{ opacity: start ? 1 : 0.5, cursor: start ? 'pointer' : 'not-allowed' }}>Next</Primary>
        </div>
      </div>

      <div>
        <EstimatedCostCard productUrls={productUrlCount} retailers={retailerCount} frequency={frequency ? (frequency.charAt(0).toUpperCase() + frequency.slice(1)) : '-'} />
      </div>
    </TwoCol>
  );
};

export default SpecsView;


